import { useState, useEffect } from "react";
import { VerifyStep } from "./VerifyStep";
import { VERIFY_STEPS } from "./constants";
import { useVerifyUserProfileMutation } from "queries";
import { VerifyStatusPopup } from "./VerifyStatusPopup";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";

interface IFileData {
  file_data: File;
  file_name: string;
}

export interface IInput {
  id: string;
  name: string;
  value: string;
  validMessage: null | string;
  isRequired: boolean;
  socialKey?: string;
  placeholder?: string;
}

interface IVerifyFromProps {
  handleStatusSent: (value: boolean) => void;
}

export const VerifyFrom = ({ handleStatusSent }: IVerifyFromProps) => {
  const [file, setFile] = useState<IFileData | null>(null);
  const [inputList, setInputList] = useState<IInput[]>([]);
  const [btnState, setBtnState] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [popupStatusText, setPopupStatusText] = useState("");
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const verifyUserProfileMutation = useVerifyUserProfileMutation();

  useEffect(() => {
    const validInputs = inputList.filter(({ value }) => !!value);
    const isRequiredInputs = validInputs.filter(({ isRequired }) => isRequired);
    const isInputs = validInputs.length > 1 && isRequiredInputs.length;

    if (isInputs && file) {
      setBtnState(true);
    } else {
      setBtnState(false);
    }

  }, [file, inputList]);

  const handleUpdateInputs = (inputs: IInput[]) => {
    setInputList(inputs);
  };

  const handleChangeFile = (data: IFileData | null) => {
    setFile(data);
  };

  const handlePopup = (isShowPopup: boolean, message: string) => {
    setPopupStatusText(message);
    setIsShowPopup(isShowPopup);
  };

  const handleTogglePopup = () => {
    setIsShowPopup(prev => !prev);
  };

  const handleVerifySend = async () => {
    const validInputs = inputList.filter(({ value }) => !!value);
    const formData = new FormData();

    setDisableSubmit(true);

    for (const { name, value, placeholder } of validInputs) {
      formData.append(`${name}`, `${placeholder}${value}`);
    }
    // @ts-ignore
    formData.append("photo", file.file_data);

    try {
      const { message } = await verifyUserProfileMutation.mutateAsync(formData);

      handlePopup(true, message);
      setDisableSubmit(true);
      setTimeout(() => {
        handleStatusSent(true);
      // eslint-disable-next-line no-magic-numbers
      }, 2000);
    } catch (e: any) {
      handlePopup(true, "Something went wrong. Please try later.");
      setDisableSubmit(false);
    }
  };

  const renderSteps = () => {
    return (
      <div className="VerifyPage-Steps">
        {VERIFY_STEPS.map((step) => (
          <VerifyStep
            handleUpdateInputs={handleUpdateInputs}
            handleChangeFile={handleChangeFile}
            inputList={inputList}
            btnState={btnState}
            disableSubmit={disableSubmit}
            key={step.index}
            userName={currentUser.username}
            handleVerifySend={handleVerifySend}
            {...step}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="VerifyPage-Steps">
      {renderSteps()}
      <VerifyStatusPopup
        isShowPopup={isShowPopup}
        content={popupStatusText}
        handleTogglePopup={handleTogglePopup}
      />
    </div>
  );
};
